import type { AnalyticsOptions } from 'owa-analytics-types';

export function getAnalyticOptions(): AnalyticsOptions {
    return {
        flightControls: {
            client_event: {
                flight: 'analytics-client-event',
                rate: 5,
            },
            client_grey_error: {
                flight: 'analytics-client-event',
                rate: 5,
            },
            client_verbose: {
                flight: 'ana-client-verbose',
                rate: 1,
            },
            client_network_request: {
                flight: 'ana-client-network-request',
                rate: 1,
            },
            client_cosmos: {
                flight: 'analytics-client-event',
                rate: 5,
            },
        },
        verboseWhiteListEvents: ['AttachmentRefreshDownloadToken', 'TabViewActivateTab'],
    };
}
